import Tooltip from "../generic-building-blocks/Tooltip";
import AddTagButton from "./AddTagButton";
import TagPill from "./TagPill";
import { ClientTag } from "@avenueops/shared-types";
import { DynamicTag } from "@prisma/client";
import { trpc, trpc2 } from "utils/trpc";

interface Props {
  tags: ClientTag[];
  parentObject: { type: "WORKFLOW" | "PROCESS" | "WORKFLOW_BULK_ACTION"; ids: string[] };
  dynamicTags?: DynamicTag[];
  workflowId?: string;
  readOnly?: boolean;
  size?: "SMALL" | "MEDIUM" | "LARGE";
}

export function TagsList({ tags, parentObject, dynamicTags, workflowId, readOnly, size = "MEDIUM" }: Props): JSX.Element {
  const utils = trpc.useContext();
  const utils2 = trpc2.useContext();

  const onRemoveSuccess = async () => {
    await utils.tags.getOrgTagsAndTaggedProcessCounts.invalidate();
    await utils2.v2.workflows.get.invalidate();
    await utils.processes.get.invalidate();
    await utils.tags.getProcessTags.invalidate();
  };

  const { mutateAsync: removeTagFromWorkflow } = trpc.tags.removeTagFromWorkflow.useMutation({ onSuccess: onRemoveSuccess });
  const { mutateAsync: removeTagFromProcess } = trpc.tags.removeTagFromProcess.useMutation({ onSuccess: onRemoveSuccess });
  const { mutateAsync: removeDynamicTagFromWorkflow } = trpc2.v2.dynamicTags.removeFromWorkflow.useMutation({ onSuccess: onRemoveSuccess });

  const removeTag = async (tagId: string) => {
    if (parentObject.type === "WORKFLOW") {
      await removeTagFromWorkflow({ workflowId: parentObject.ids[0], tagId });
    } else {
      await removeTagFromProcess({ processId: parentObject.ids[0], tagId });
    }
  };

  const removeDynamicTag = async (workflowColumn: string) => {
    await removeDynamicTagFromWorkflow({ workflowId: parentObject.ids[0], workflowColumn });
  };
  return (
    <div className="flex flex-row gap-2 whitespace-nowrap flex-wrap">
      {tags.map((tag) => (
        <div className="max-w-full" key={tag.id}>
          <TagPill workflowId={workflowId} tag={tag} name={tag.name} removeTag={readOnly ? undefined : removeTag} size={size} />
        </div>
      ))}
      {parentObject.type === "WORKFLOW" && dynamicTags && dynamicTags.length > 0
        ? dynamicTags.map((dynamicTag) => (
            <div className="max-w-full" key={dynamicTag.id}>
              <TagPill name={dynamicTag.workflowColumn} removeTag={readOnly ? undefined : removeDynamicTag} size={size} />
            </div>
          ))
        : null}
      {!readOnly ? <AddTagButton workflowId={workflowId} parentObject={parentObject} currentTags={tags ?? []} size={size} /> : null}
    </div>
  );
}
